module.exports = __webpack_public_path__ + "img/huizhi.88971709.jpg";